import { IndentValues } from "@/lib/utils/IndentValues";
import { SpacingValues } from "@/lib/utils/SpacingValues";
import { css, Global } from "@emotion/react";
import { Row, SeparatorLine, Spacing } from "@stenajs-webui/core";
import React from "react";
import { Helmet } from "react-helmet";
import { NslhPageHeader } from "../NslhPageHeader";
import { InvoiceSpecificationList } from "./components/InvoiceSpecificationList";
import { SearchInvoiceFilterBar } from "./components/SearchInvoiceFilterBar";

export const SearchInvoicesScreen: React.FC = () => {
  return (
    <>
      <Global
        styles={css`
          body {
            display: table;
          }
        `}
      />
      <Helmet title="Invoice specification - NSLH - FPP" />
      <NslhPageHeader
        actionBar={<SearchInvoiceFilterBar />}
        headingText={"Follow up"}
      />
      <Row indent={IndentValues.TWENTYFOUR}>
        <InvoiceSpecificationList />
        <Spacing num={IndentValues.TWENTYFOUR} />
      </Row>
    </>
  );
};
